import ApiClient from "./apiClient";

type UkrsibConfigPayload = {
  enabled?: boolean;
  test_mode?: boolean;
  state?: string;
  client_id?: string;
  client_secret?: string;
  private_certificate?: string;
  private_passphrase?: string | null;
  accounts?: string[];
}

const ukrsibService = {
  // Получение конфигурации
  getConfig: () => ApiClient.get('billing/ukrsib'),

  // Обновление конфигурации
  updateConfig: (data: UkrsibConfigPayload) => ApiClient.patch('billing/ukrsib', data),

  // Получение статуса
  getStatus: () => ApiClient.get('billing/ukrsib/status'),

  // Генерация Auth URL
  generateAuthUrl: () => ApiClient.post('billing/ukrsib/gen_auth_url'),

  // Авторизация
  authorize: () => ApiClient.post('billing/ukrsib/authorize'),
}

export default ukrsibService;
